import { mergeWith } from 'ramda';

import { TNextStepArguments, TStep } from '../../../types/form';
import { TCurrentQuestionEnhanced, TQuestionMap } from '../types/internal';
import { ECode } from '../../../repositories/lead-realtor-form/entities/question/QuestionSchema';

interface IParams {
  currentStep: TStep;
  currentStepArgs?: TNextStepArguments | null;
  questionsMap: TQuestionMap;
  withSaleRentIntroScreen: boolean;
}

/**
 * Собирает составляющие части вопроса в единый объект TCurrentQuestionEnhanced
 * */
export const prepareCurrentQuestion = (params: IParams): TCurrentQuestionEnhanced => {
  const { currentStep, currentStepArgs, questionsMap, withSaleRentIntroScreen } = params;
  /**
   * Объект вопроса обогощается доп.аргументами, которые прокидываются из шага (nextStep -> nextStepArgs)
   * mergeWith применен, чтоб не потерять аргументы из _currentQuestion, если в currentStepArgs они же имеют знач. null
   * к примеру, если в _currentQuestion верный title, а в currentStepArgs {title: null}, то title сохранится из _currentQuestion
   * */
  const questionBase = questionsMap[currentStep.questionCode];
  const questionWithArgsFromStep: TCurrentQuestionEnhanced = mergeWith(
    (l, r) => r || l,
    questionBase,
    currentStepArgs || {},
  );

  Object.assign(questionWithArgsFromStep, {
    required: currentStep.required,
    extras: currentStep.extras,
  });

  /**
   * Если отображаем интро экран Куплю/Сниму, в первом вопросе
   * "Чем риелтор может вам помочь?" отображаем только 2 варианта ответа - Купить/Снять
   */
  if (withSaleRentIntroScreen && questionWithArgsFromStep.code === ECode.DealTypeEx) {
    return {
      ...questionWithArgsFromStep,
      answers: questionWithArgsFromStep.answers?.filter(answer => ['buy', 'tenant'].includes(answer.value)),
    };
  }

  return questionWithArgsFromStep;
};
